import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LocationToggle = ({ isLocalFirst, onToggle, userLocation, onLocationRequest }) => {
  return (
    <div className="flex items-center justify-between mb-6 p-4 bg-card rounded-lg border border-border">
      <div className="flex items-center space-x-3">
        <Icon name="MapPin" size={20} className="text-primary" />
        <div>
          <p className="text-sm font-body font-semibold text-foreground">
            {isLocalFirst ? 'Showing local results' : 'Showing UK-wide results'}
          </p>
          <p className="text-xs text-muted-foreground">
            {userLocation 
              ? `Near ${userLocation}` 
              : 'Location not set'
            }
          </p>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        {!userLocation && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onLocationRequest}
            iconName="Navigation"
            iconPosition="left"
            iconSize={14}
          >
            Set Location
          </Button>
        )}
        
        <Button
          variant={isLocalFirst ? "default" : "outline"}
          size="sm"
          onClick={onToggle}
          iconName={isLocalFirst ? "MapPin" : "Globe"}
          iconPosition="left"
          iconSize={14}
        >
          {isLocalFirst ? 'Local' : 'UK-wide'}
        </Button>
      </div>
    </div>
  );
};

export default LocationToggle;